var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00277 8.00114C8.8437 8.00114 10.3361 6.50875 10.3361 4.66781C10.3361 2.82686 8.8437 1.33447 7.00277 1.33447C5.16182 1.33447 3.66943 2.82686 3.66943 4.66781C3.66943 6.50875 5.16182 8.00114 7.00277 8.00114Z",
    stroke: "#313131",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7321 14.6679C12.7321 12.0879 10.1655 10.0012 7.0055 10.0012C3.84547 10.0012 1.27881 12.0879 1.27881 14.6679",
    stroke: "#313131",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon2);
export default __webpack_public_path__ + "static/media/personIcon2.eebf6661745bac176e0844ccd50c08d0.svg";
export { ForwardRef as ReactComponent };